import { writable } from "svelte/store";

export const mobile_menu = writable(false);